import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./application-notes.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./application-notes.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../services/route-params.service";
import { SaLongDatePipe } from "../../pipes/sa-long-date/sa-long-date.pipe";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { aflaModuleServiceProvider } from "../../services/afla-module-strategy/afla-module-strategy.service.provider";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let ApplicationNotesComponent = class ApplicationNotesComponent extends ApplicationBaseComponent {
    currentStepService;
    saLongDatePipe;
    changeDetectorRefs;
    aflaModuleStrategyService;
    route;
    routerParamsService;
    notes = [];
    subscribeToCurrentStepsSubscription;
    constructor(currentStepService, saLongDatePipe, changeDetectorRefs, aflaModuleStrategyService, route, routerParamsService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.currentStepService = currentStepService;
        this.saLongDatePipe = saLongDatePipe;
        this.changeDetectorRefs = changeDetectorRefs;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        //this.subscribeToCurrentSteps();
    }
    handleRouteChange() {
        this.currentStepService.getCurrentNotes(this.jobID).subscribe({ next: data => {
                this.notes = [];
                if (data !== null) {
                    data.value.forEach(note => {
                        let noteText = "";
                        if (note.stepId !== null) {
                            noteText = `${note.note} - ${note.step.stepName}`;
                        }
                        else {
                            noteText = `${note.note}`;
                        }
                        const noteView = {
                            id: note.id,
                            date: this.saLongDatePipe.transform(note.date),
                            note: noteText,
                            jobId: note.jobId,
                            stepId: note.stepId,
                            userId: note.userId,
                            deleted: note.deleted,
                            userName: "",
                            stepName: "",
                            canDelete: false,
                            workflowStepId: note.workflowStepId,
                        };
                        if (note.user !== undefined && note.user !== null) {
                            noteView.userName = note.user.firstName + " " + note.user.lastName;
                        }
                        this.notes.push(noteView);
                    });
                    this.notes.sort((a, b) => 0 - (a.date.toLowerCase() < b.date.toLowerCase() ? -1 : 1));
                    let count = 10;
                    if (data.value.length < count) {
                        count = data.value.length;
                    }
                    this.notes = this.notes.slice(0, count);
                }
                this.changeDetectorRefs.detectChanges();
            }, error: error => { } });
    }
    static ctorParameters = () => [
        { type: CurrentStepService },
        { type: SaLongDatePipe },
        { type: ChangeDetectorRef },
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService }
    ];
};
ApplicationNotesComponent = __decorate([
    Component({
        selector: "app-application-notes",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ApplicationNotesComponent);
export { ApplicationNotesComponent };
